(ns frontend.ui.component.lp-portal.report.body.lifeline.holding.pdf
  (:require
   [clojure.math :as math]
   [common.util :as cu]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.report.component.horizontal-table.pdf-view :as horizontal-table-pdf]
   [frontend.ui.component.lp-portal.report.component.vertical-table.pdf-view :as vertical-table-pdf]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.voima-components.pdf.card.view :as card]
   [frontend.ui.component.lp-portal.voima-components.pdf.column.view :as column]
   [frontend.ui.style.theme.core :as theme]))

(defn description-text
  [data]
  (let [rich-content (->> data
                          :description
                          :rich-content)]
    (when-not (cu/blank-value? rich-content)
      [(card/custom-margins-card
        {:title       "Description"
         :title-color (theme/color [:palette :white])}
        [8 8 8 0]
        (text-content/rich-content rich-content
                                   {:text-color (theme/color [:palette :white])}))])))

(defn significant-events-text
  [data]
  (let [rich-content (->> data
                          :significant-events
                          :rich-content)]
    (when-not (cu/blank-value? rich-content)
      [(card/custom-margins-card
        {:title       "Significant events"
         :title-color (theme/color [:palette :white])}
        [8 8 8 0]
        (text-content/rich-content rich-content
                                   {:text-color (theme/color [:palette :white])}))])))

(defn company-information-table
  [data]
  [(card/custom-margins-card
    ""
    [8 8 8 0]
    (vertical-table-pdf/table (:company-information data)
                           {:font-size 8
                            :text-color (theme/color [:palette :white])}))])

(defn investment-information-table
  [data]
  (let [info              (:investment-information data)
        all-rows          (-> info :figures :rows)
        split-idx         (math/round (/ (count all-rows) 2))
        first-half        (assoc-in info [:figures :rows] (subvec all-rows 0 split-idx))
        second-half       (assoc-in info [:figures :rows] (subvec all-rows split-idx))]
    [(card/table-card
      "Investment"
      (column/columns [(vertical-table-pdf/table first-half
                                              {:font-size 7
                                               :table-widths [150 *]})]
                      [(vertical-table-pdf/table second-half
                                              {:font-size 7
                                               :table-widths [150 *]})]))]))

(defn financials-table
  [data]
  [(card/table-card
    "Financials"
    (vertical-table-pdf/table (:financials-table data)
                              {:font-size 7}))])

(defn latest-transactions-table
  [data]
  [(card/table-card
    "Latest transactions"
    (horizontal-table-pdf/table (:latest-transactions data)
                                {:font-size 7})
    (text-content/optional-footer (->  data
                                       :latest-transactions)))])

(defn company-page
  [data]
  (let [{:keys [holding-name logo-image cross-fund-investment?]}
        data]
    (page/page
     (page/first-column-background-lifeline-holding)
     (page/holding-page-logo {:page-title
                              holding-name
                              :holding-logo (:image logo-image)
                              :cross-fund-investment? cross-fund-investment?})
     [(column/columns-1-to-2
       [(company-information-table data)
        (description-text data)
        (significant-events-text data)]
       [(investment-information-table data)
        (financials-table data)
        (latest-transactions-table data)])])))

(defn exited-company-page
  [data]
  (let [{:keys [holding-name logo-image cross-fund-investment?]}
        data]
    (page/page
     (page/first-column-background-lifeline-holding)
     (page/holding-page-logo {:page-title
                              holding-name
                              :holding-logo (:image logo-image)
                              :exited? true
                              :cross-fund-investment? cross-fund-investment?})
     [(column/columns-1-to-2
       [(company-information-table data)
        (description-text data)
        (significant-events-text data)]
       [(investment-information-table data)
        (financials-table data)
        (latest-transactions-table data)])])))


(defn holding-pages
  [data]
  (concat [(company-page data)]))

(defn exited-holding-pages
  [data]
  (concat [(exited-company-page data)]))
